export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 19.7143V9.42857C2 9.06667 2.08875 8.72381 2.26625 8.4C2.44375 8.07619 2.68833 7.80952 3 7.6L10.5 2.45714C10.9375 2.15238 11.4375 2 12 2C12.5625 2 13.0625 2.15238 13.5 2.45714L21 7.6C21.3125 7.80952 21.5575 8.07619 21.735 8.4C21.9125 8.72381 22.0008 9.06667 22 9.42857V19.7143C22 20.3429 21.755 20.8811 21.265 21.3291C20.775 21.7771 20.1867 22.0008 19.5 22H15.75C15.3958 22 15.0992 21.8903 14.86 21.6709C14.6208 21.4514 14.5008 21.1802 14.5 20.8571V15.1429C14.5 14.819 14.38 14.5478 14.14 14.3291C13.9 14.1105 13.6033 14.0008 13.25 14H10.75C10.3958 14 10.0992 14.1097 9.86 14.3291C9.62083 14.5486 9.50083 14.8198 9.5 15.1429V20.8571C9.5 21.181 9.38 21.4526 9.14 21.672C8.9 21.8914 8.60333 22.0008 8.25 22H4.5C3.8125 22 3.22417 21.7764 2.735 21.3291C2.24583 20.8819 2.00083 20.3436 2 19.7143Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.85714 6.23077C4.85714 5.1087 5.27104 4.03259 6.00779 3.23916C6.74454 2.44574 7.74379 2 8.78571 2C9.82764 2 10.8269 2.44574 11.5636 3.23916C12.3004 4.03259 12.7143 5.1087 12.7143 6.23077C12.7143 7.35284 12.3004 8.42895 11.5636 9.22237C10.8269 10.0158 9.82764 10.4615 8.78571 10.4615C7.74379 10.4615 6.74454 10.0158 6.00779 9.22237C5.27104 8.42895 4.85714 7.35284 4.85714 6.23077ZM14.1429 8.53846C14.1429 8.08388 14.226 7.63376 14.3875 7.21378C14.5491 6.79381 14.7858 6.41221 15.0843 6.09078C15.3828 5.76935 15.7371 5.51437 16.1271 5.34041C16.5171 5.16646 16.935 5.07692 17.3571 5.07692C17.7792 5.07692 18.1972 5.16646 18.5872 5.34041C18.9772 5.51437 19.3315 5.76935 19.63 6.09078C19.9285 6.41221 20.1652 6.79381 20.3268 7.21378C20.4883 7.63376 20.5714 8.08388 20.5714 8.53846C20.5714 9.45651 20.2328 10.337 19.63 10.9861C19.0272 11.6353 18.2096 12 17.3571 12C16.5047 12 15.6871 11.6353 15.0843 10.9861C14.4815 10.337 14.1429 9.45651 14.1429 8.53846ZM2 19.3077C2 17.3696 2.71492 15.5108 3.98749 14.1404C5.26006 12.7699 6.98603 12 8.78571 12C10.5854 12 12.3114 12.7699 13.5839 14.1404C14.8565 15.5108 15.5714 17.3696 15.5714 19.3077V19.3108L15.5705 19.4328C15.5685 19.5632 15.5357 19.691 15.4752 19.804C15.4147 19.9171 15.3285 20.0117 15.2248 20.079C13.2811 21.3393 11.0545 22.0036 8.78571 22C6.43143 22 4.22762 21.2985 2.34762 20.079C2.24367 20.0118 2.1573 19.9172 2.09665 19.8042C2.03601 19.6911 2.00307 19.5633 2.00095 19.4328L2 19.3077ZM17 19.3108L16.999 19.4585C16.9937 19.8003 16.9179 20.1366 16.7771 20.4431C16.9689 20.4554 17.1622 20.4615 17.3571 20.4615C18.8771 20.4615 20.3162 20.082 21.5962 19.4061C21.7117 19.3453 21.8099 19.2521 21.8803 19.1362C21.9507 19.0203 21.9907 18.886 21.9962 18.7477L22 18.5385C22.0001 17.6952 21.8022 16.8656 21.4247 16.1268C21.0471 15.3881 20.5022 14.7641 19.8407 14.313C19.1791 13.862 18.4223 13.5984 17.6407 13.5469C16.8592 13.4954 16.0782 13.6576 15.3705 14.0185C16.4298 15.5457 17.0012 17.4014 16.999 19.3077L17 19.3108Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const VerifiedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.4037 2.09852C10.5063 2.03428 10.6268 2 10.75 2C10.8732 2 10.9937 2.03428 11.0963 2.09852C13.4561 3.59583 16.1461 4.5697 18.9637 4.9468C19.1126 4.9669 19.2488 5.03685 19.3473 5.14382C19.4458 5.25079 19.5 5.38761 19.5 5.52916V10.941C18.0976 10.2669 16.4919 10.0662 14.9512 10.3727C13.4106 10.6791 12.0284 11.4741 11.0358 12.6246C10.0431 13.7752 9.50022 15.2115 9.49781 16.6936C9.49539 18.1757 10.0336 19.6136 11.0225 20.767L10.975 20.7847C10.8302 20.8373 10.6698 20.8373 10.525 20.7847C4.885 18.7411 2 15.3999 2 10.8234V5.52916C2.00002 5.38743 2.05441 5.25048 2.15317 5.14348C2.25192 5.03648 2.3884 4.96664 2.5375 4.9468C5.35471 4.56953 8.04429 3.59567 10.4037 2.09852ZM22 16.7058C22 15.3017 21.4074 13.9551 20.3525 12.9622C19.2976 11.9694 17.8668 11.4116 16.375 11.4116C14.8832 11.4116 13.4524 11.9694 12.3975 12.9622C11.3426 13.9551 10.75 15.3017 10.75 16.7058C10.75 18.1099 11.3426 19.4565 12.3975 20.4494C13.4524 21.4422 14.8832 22 16.375 22C17.8668 22 19.2976 21.4422 20.3525 20.4494C21.4074 19.4565 22 18.1099 22 16.7058ZM19.3175 14.5246C19.3757 14.5792 19.4219 14.6441 19.4534 14.7156C19.4849 14.7871 19.5011 14.8637 19.5011 14.9411C19.5011 15.0184 19.4849 15.0951 19.4534 15.1665C19.4219 15.238 19.3757 15.3029 19.3175 15.3575L15.5675 18.887C15.5094 18.9418 15.4405 18.9853 15.3645 19.0149C15.2886 19.0446 15.2072 19.0598 15.125 19.0598C15.0428 19.0598 14.9614 19.0446 14.8855 19.0149C14.8095 18.9853 14.7406 18.9418 14.6825 18.887L13.4325 17.7105C13.3151 17.6001 13.2492 17.4503 13.2492 17.294C13.2492 17.1378 13.3151 16.988 13.4325 16.8776C13.5499 16.7671 13.709 16.7051 13.875 16.7051C14.041 16.7051 14.2001 16.7671 14.3175 16.8776L15.125 17.6388L18.4325 14.5246C18.4906 14.4698 18.5595 14.4263 18.6355 14.3967C18.7114 14.367 18.7928 14.3518 18.875 14.3518C18.9572 14.3518 19.0386 14.367 19.1145 14.3967C19.1905 14.4263 19.2594 14.4698 19.3175 14.5246Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PencilIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.69095 7V2H4.30728C3.69535 2 3.10849 2.22576 2.67579 2.62763C2.24309 3.02949 2 3.57454 2 4.14286V19.8571C2 20.4255 2.24309 20.9705 2.67579 21.3724C3.10849 21.7742 3.69535 22 4.30728 22H15.0746C15.6865 22 16.2734 21.7742 16.7061 21.3724C17.1388 20.9705 17.3819 20.4255 17.3819 19.8571V16.3743L14.8177 18.7557C14.1871 19.3414 13.3964 19.7557 12.532 19.9571L10.2278 20.4914C9.5986 20.6389 8.93437 20.5861 8.34127 20.3416C7.74816 20.0972 7.26043 19.6751 6.95605 19.1429H4.30728C4.10331 19.1429 3.90769 19.0676 3.76345 18.9336C3.61922 18.7997 3.53819 18.618 3.53819 18.4286C3.53819 18.2391 3.61922 18.0574 3.76345 17.9235C3.90769 17.7895 4.10331 17.7143 4.30728 17.7143H6.62072C6.63271 17.5471 6.6605 17.3812 6.70378 17.2186L7.28061 15.0786C7.49665 14.2759 7.94321 13.5427 8.57268 12.9571L12.6812 9.14286H11.9982C11.3863 9.14286 10.7994 8.91709 10.3667 8.51523C9.93404 8.11337 9.69095 7.56832 9.69095 7ZM11.2291 2.35714L15.6084 6.42429L14.2194 7.71429H11.9982C11.7943 7.71429 11.5986 7.63903 11.4544 7.50508C11.3102 7.37112 11.2291 7.18944 11.2291 7V2.35714ZM9.66018 13.9671L17.0896 7.06714C17.3569 6.81913 17.6741 6.62244 18.0232 6.48829C18.3723 6.35414 18.7464 6.28516 19.1242 6.28529C19.502 6.28542 19.8761 6.35466 20.2251 6.48906C20.574 6.62345 20.8911 6.82037 21.1582 7.06857C21.4252 7.31677 21.637 7.61139 21.7814 7.9356C21.9259 8.25982 22.0001 8.60728 22 8.95815C21.9999 9.30903 21.9253 9.65644 21.7806 9.98055C21.6359 10.3047 21.4239 10.5991 21.1566 10.8471L13.7272 17.7457C13.2942 18.1477 12.752 18.4331 12.1582 18.5714L9.854 19.1057C9.62488 19.1587 9.38489 19.1558 9.15734 19.0973C8.9298 19.0387 8.72243 18.9265 8.55539 18.7715C8.38834 18.6165 8.26731 18.424 8.20403 18.2127C8.14076 18.0014 8.1374 17.7786 8.19429 17.5657L8.77111 15.4257C8.9201 14.8743 9.22737 14.3707 9.66018 13.9686"
        fill="currentColor"
      />
    </svg>
  );
};
export const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.3333 3.53846H17.8333V2.76923C17.8333 2.56522 17.7455 2.36956 17.5893 2.2253C17.433 2.08104 17.221 2 17 2C16.779 2 16.567 2.08104 16.4107 2.2253C16.2545 2.36956 16.1667 2.56522 16.1667 2.76923V3.53846H7.83333V2.76923C7.83333 2.56522 7.74554 2.36956 7.58926 2.2253C7.43297 2.08104 7.22101 2 7 2C6.77899 2 6.56702 2.08104 6.41074 2.2253C6.25446 2.36956 6.16667 2.56522 6.16667 2.76923V3.53846H3.66667C3.22464 3.53846 2.80072 3.70055 2.48816 3.98907C2.17559 4.27758 2 4.6689 2 5.07692V20.4615C2 20.8696 2.17559 21.2609 2.48816 21.5494C2.80072 21.8379 3.22464 22 3.66667 22H20.3333C20.7754 22 21.1993 21.8379 21.5118 21.5494C21.8244 21.2609 22 20.8696 22 20.4615V5.07692C22 4.6689 21.8244 4.27758 21.5118 3.98907C21.1993 3.70055 20.7754 3.53846 20.3333 3.53846ZM10.3333 18.1538C10.3333 18.3579 10.2455 18.5535 10.0893 18.6978C9.93297 18.842 9.72101 18.9231 9.5 18.9231C9.27899 18.9231 9.06702 18.842 8.91074 18.6978C8.75446 18.5535 8.66667 18.3579 8.66667 18.1538V13.2442L8.20625 13.4577C8.00844 13.549 7.77945 13.564 7.56964 13.4995C7.35984 13.4349 7.1864 13.2961 7.0875 13.1135C6.9886 12.9309 6.97232 12.7195 7.04226 12.5258C7.11219 12.3322 7.26261 12.1721 7.46042 12.0808L9.12708 11.3115C9.25418 11.2528 9.39543 11.2251 9.53741 11.231C9.67938 11.2369 9.81737 11.2762 9.93825 11.3452C10.0591 11.4142 10.1589 11.5106 10.228 11.6252C10.2972 11.7398 10.3334 11.8688 10.3333 12V18.1538ZM16.1667 17.3846C16.3877 17.3846 16.5996 17.4657 16.7559 17.6099C16.9122 17.7542 17 17.9498 17 18.1538C17 18.3579 16.9122 18.5535 16.7559 18.6978C16.5996 18.842 16.3877 18.9231 16.1667 18.9231H12.8333C12.6786 18.9231 12.5269 18.8833 12.3952 18.8082C12.2636 18.7331 12.1572 18.6256 12.088 18.4979C12.0188 18.3701 11.9895 18.227 12.0034 18.0848C12.0173 17.9425 12.0738 17.8066 12.1667 17.6923L15.1646 14.0029C15.2328 13.9191 15.2817 13.8233 15.3083 13.7214C15.335 13.6196 15.3388 13.5137 15.3196 13.4104C15.3003 13.3072 15.2584 13.2086 15.1964 13.1208C15.1344 13.033 15.0536 12.9578 14.959 12.8999C14.8644 12.842 14.7579 12.8025 14.6462 12.7839C14.5344 12.7653 14.4198 12.7679 14.3092 12.7917C14.1986 12.8155 14.0945 12.8599 14.0032 12.9222C13.9118 12.9844 13.8353 13.0633 13.7781 13.1538C13.725 13.2441 13.6529 13.3237 13.5659 13.3878C13.479 13.4519 13.379 13.4993 13.2719 13.5271C13.1648 13.555 13.0527 13.5628 12.9423 13.55C12.8319 13.5373 12.7253 13.5042 12.629 13.4529C12.5326 13.4015 12.4484 13.3328 12.3812 13.2509C12.3141 13.169 12.2654 13.0755 12.238 12.9759C12.2107 12.8763 12.2052 12.7727 12.2219 12.6712C12.2386 12.5696 12.2772 12.4722 12.3354 12.3846C12.6107 11.9449 13.0354 11.6013 13.5438 11.407C14.0521 11.2128 14.6157 11.1787 15.1471 11.3102C15.6785 11.4416 16.1482 11.7312 16.4831 12.1341C16.8181 12.537 16.9998 13.0306 17 13.5385C17.0018 14.0401 16.8246 14.5284 16.4958 14.9279L14.5 17.3846H16.1667ZM3.66667 8.15385V5.07692H6.16667V5.84615C6.16667 6.05017 6.25446 6.24582 6.41074 6.39008C6.56702 6.53434 6.77899 6.61538 7 6.61538C7.22101 6.61538 7.43297 6.53434 7.58926 6.39008C7.74554 6.24582 7.83333 6.05017 7.83333 5.84615V5.07692H16.1667V5.84615C16.1667 6.05017 16.2545 6.24582 16.4107 6.39008C16.567 6.53434 16.779 6.61538 17 6.61538C17.221 6.61538 17.433 6.53434 17.5893 6.39008C17.7455 6.24582 17.8333 6.05017 17.8333 5.84615V5.07692H20.3333V8.15385H3.66667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.4615 4.75003C20.4615 4.02068 20.1644 3.3212 19.6354 2.80547C19.1065 2.28973 18.3891 2 17.641 2H4.82051C4.07247 2 3.35506 2.28973 2.82611 2.80547C2.29716 3.3212 2 4.02068 2 4.75003V17.2502C2 17.9795 2.29716 18.679 2.82611 19.1947C3.35506 19.7105 4.07247 20.0002 4.82051 20.0002H11.2533C10.4721 18.8119 10.1109 17.4072 10.2246 16.0002H5.84615C5.65126 16.0001 5.46365 15.9279 5.32124 15.7982C5.17883 15.6685 5.09223 15.4909 5.07895 15.3013C5.06566 15.1117 5.12668 14.9243 5.24967 14.7768C5.37267 14.6294 5.54846 14.533 5.74154 14.5071L5.84615 14.5001H10.5262C10.8373 13.5642 11.3623 12.7094 12.0615 12.0001H5.84615C5.65126 12.0001 5.46365 11.9279 5.32124 11.7981C5.17883 11.6684 5.09223 11.4908 5.07895 11.3012C5.06566 11.1116 5.12668 10.9242 5.24967 10.7768C5.37267 10.6294 5.54846 10.533 5.74154 10.5071L5.84615 10.5001H13.5385C13.7046 10.5001 13.8595 10.5521 13.9846 10.6401C14.8856 10.2185 15.8724 9.99972 16.8718 10.0001C18.1441 9.99818 19.3902 10.3529 20.4615 11.0221V4.75003ZM16.6154 6.50005C16.8103 6.50011 16.9979 6.5723 17.1403 6.70202C17.2827 6.83175 17.3693 7.00935 17.3826 7.19894C17.3959 7.38852 17.3349 7.57595 17.2119 7.72336C17.0889 7.87077 16.9131 7.96717 16.72 7.99307L16.6154 8.00007H5.84615C5.65126 8.00001 5.46365 7.92782 5.32124 7.79809C5.17883 7.66836 5.09223 7.49076 5.07895 7.30118C5.06566 7.1116 5.12668 6.92416 5.24967 6.77675C5.37267 6.62935 5.54846 6.53295 5.74154 6.50705L5.84615 6.50005H16.6154ZM11.7436 14.6291L12.2021 15.0591C12.4009 15.2457 12.5591 15.4695 12.6671 15.7172C12.7752 15.9648 12.8309 16.2311 12.8309 16.5002C12.8309 16.7692 12.7752 17.0356 12.6671 17.2832C12.5591 17.5308 12.4009 17.7546 12.2021 17.9412L11.7436 18.3712C11.9487 18.9452 12.2462 19.4742 12.6185 19.9412L13.2359 19.7632C13.5026 19.6865 13.7825 19.6635 14.0587 19.6956C14.3348 19.7277 14.6013 19.8141 14.8421 19.9498C15.0829 20.0854 15.2929 20.2673 15.4593 20.4845C15.6257 20.7017 15.7451 20.9496 15.8103 21.2132L15.9887 21.9282C16.5733 22.0239 17.1702 22.0239 17.7549 21.9282L17.9323 21.2122C17.9975 20.9486 18.117 20.7007 18.2836 20.4835C18.4501 20.2664 18.6602 20.0845 18.9011 19.9489C19.142 19.8134 19.4087 19.7271 19.6848 19.6951C19.961 19.6632 20.241 19.6864 20.5077 19.7632L21.1251 19.9412C21.4964 19.4742 21.7938 18.9452 22 18.3712L21.5415 17.9412C21.3427 17.7546 21.1845 17.5308 21.0765 17.2832C20.9684 17.0356 20.9127 16.7692 20.9127 16.5002C20.9127 16.2311 20.9684 15.9648 21.0765 15.7172C21.1845 15.4695 21.3427 15.2457 21.5415 15.0591L22 14.6291C21.7981 14.0628 21.5026 13.5325 21.1251 13.0591L20.5077 13.2371C20.241 13.3138 19.9611 13.3368 19.6849 13.3047C19.4088 13.2727 19.1423 13.1862 18.9015 13.0506C18.6607 12.9149 18.4507 12.733 18.2843 12.5158C18.1179 12.2986 17.9985 12.0507 17.9333 11.7871L17.7549 11.0721C17.1699 10.9763 16.5727 10.9763 15.9877 11.0721L15.8113 11.7881C15.7461 12.0517 15.6265 12.2996 15.46 12.5168C15.2934 12.734 15.0833 12.9158 14.8425 13.0514C14.6016 13.1869 14.3349 13.2733 14.0588 13.3052C13.7826 13.3371 13.5026 13.314 13.2359 13.2371L12.6185 13.0591C12.241 13.5325 11.9455 14.0628 11.7436 14.6291ZM16.8718 18.0002C16.0513 18.0002 15.3846 17.3282 15.3846 16.5002C15.3846 15.6722 16.0513 15.0001 16.8718 15.0001C17.6923 15.0001 18.359 15.6722 18.359 16.5002C18.359 17.3282 17.6923 18.0002 16.8718 18.0002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 2C19.0609 2 20.0783 2.44361 20.8284 3.23324C21.5786 4.02288 22 5.09385 22 6.21056V14.6317C22 15.7484 21.5786 16.8194 20.8284 17.609C20.0783 18.3986 19.0609 18.8422 18 18.8422H15.414L12.707 21.6917C12.5348 21.873 12.3057 21.9818 12.0627 21.9979C11.8197 22.014 11.5794 21.9362 11.387 21.7791L11.293 21.6917L8.585 18.8422H6C4.97376 18.8422 3.98677 18.427 3.24319 17.6825C2.4996 16.938 2.05631 15.9211 2.005 14.8422L2 14.6317V6.21056C2 5.09385 2.42143 4.02288 3.17157 3.23324C3.92172 2.44361 4.93913 2 6 2H18ZM14 11.4738H8C7.73478 11.4738 7.48043 11.5847 7.29289 11.7821C7.10536 11.9795 7 12.2472 7 12.5264C7 12.8056 7.10536 13.0733 7.29289 13.2707C7.48043 13.4681 7.73478 13.579 8 13.579H14C14.2652 13.579 14.5196 13.4681 14.7071 13.2707C14.8946 13.0733 15 12.8056 15 12.5264C15 12.2472 14.8946 11.9795 14.7071 11.7821C14.5196 11.5847 14.2652 11.4738 14 11.4738ZM16 7.2632H8C7.73478 7.2632 7.48043 7.3741 7.29289 7.57151C7.10536 7.76892 7 8.03666 7 8.31584C7 8.59501 7.10536 8.86276 7.29289 9.06016C7.48043 9.25757 7.73478 9.36847 8 9.36847H16C16.2652 9.36847 16.5196 9.25757 16.7071 9.06016C16.8946 8.86276 17 8.59501 17 8.31584C17 8.03666 16.8946 7.76892 16.7071 7.57151C16.5196 7.3741 16.2652 7.2632 16 7.2632Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 18.2476L21.7718 18.0627C21.1246 17.5327 20.558 16.9252 20.0872 16.2564C19.5728 15.3334 19.2647 14.3251 19.1812 13.291V10.2456C19.1857 8.62149 18.5443 7.05182 17.3777 5.83148C16.211 4.61113 14.5994 3.82411 12.8456 3.61829V2.82302C12.8456 2.60474 12.7512 2.3954 12.5832 2.24106C12.4152 2.08671 12.1873 2 11.9497 2C11.712 2 11.4841 2.08671 11.3161 2.24106C11.1481 2.3954 11.0537 2.60474 11.0537 2.82302V3.63062C9.31561 3.85128 7.72347 4.64306 6.57217 5.8593C5.42086 7.07555 4.78841 8.63384 4.79195 10.2456V13.291C4.70843 14.3251 4.40036 15.3334 3.88591 16.2564C3.42341 16.9236 2.8659 17.5311 2.22819 18.0627L2 18.2476V19.9861H22V18.2476Z"
        fill="#2D2F32"
      />
      <path
        d="M10.3574 20.5943C10.4114 20.9839 10.6046 21.3409 10.9014 21.5993C11.1982 21.8577 11.5786 22 11.9722 22C12.3659 22 12.7462 21.8577 13.043 21.5993C13.3398 21.3409 13.5331 20.9839 13.587 20.5943H10.3574Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4601 12.3184L17.7639 16.6222C17.9151 16.7736 18.0001 16.9788 18 17.1928C17.9999 17.4069 17.9148 17.6121 17.7635 17.7633C17.6121 17.9146 17.4068 17.9996 17.1928 17.9995C16.9788 17.9994 16.7736 17.9143 16.6223 17.7629L12.3185 13.4591C11.0319 14.4556 9.41407 14.9246 7.79403 14.7706C6.17398 14.6165 4.67346 13.8511 3.59771 12.6301C2.52196 11.409 1.95179 9.82396 2.0032 8.19742C2.0546 6.57088 2.72372 5.02502 3.87443 3.87431C5.02514 2.7236 6.57101 2.05448 8.19754 2.00307C9.82408 1.95167 11.4091 2.52183 12.6302 3.59758C13.8513 4.67333 14.6167 6.17386 14.7707 7.79391C14.9247 9.41395 14.4558 11.0318 13.4593 12.3184M8.4003 13.1992C9.67328 13.1992 10.8941 12.6935 11.7943 11.7933C12.6944 10.8932 13.2001 9.67236 13.2001 8.39938C13.2001 7.1264 12.6944 5.90555 11.7943 5.00542C10.8941 4.10529 9.67328 3.5996 8.4003 3.5996C7.12732 3.5996 5.90648 4.10529 5.00634 5.00542C4.10621 5.90555 3.60052 7.1264 3.60052 8.39938C3.60052 9.67236 4.10621 10.8932 5.00634 11.7933C5.90648 12.6935 7.12732 13.1992 8.4003 13.1992Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowUpDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2931 7.71081C10.1056 7.52362 10.0003 7.26977 10.0003 7.00508C10.0003 6.74039 10.1056 6.48654 10.2931 6.29935L13.2933 3.30474C13.3856 3.2094 13.4959 3.13336 13.618 3.08104C13.74 3.02873 13.8712 3.00119 14.004 3.00004C14.1368 2.99889 14.2685 3.02414 14.3914 3.07433C14.5143 3.12452 14.6259 3.19864 14.7198 3.29237C14.8137 3.38609 14.888 3.49754 14.9383 3.62022C14.9886 3.74289 15.0139 3.87434 15.0127 4.00688C15.0116 4.13942 14.984 4.2704 14.9316 4.39219C14.8791 4.51397 14.803 4.62412 14.7074 4.7162L11.7072 7.71081C11.5197 7.89794 11.2653 8.00307 11.0002 8.00307C10.735 8.00307 10.4806 7.89794 10.2931 7.71081Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.7072 7.71079C17.5197 7.89792 17.2653 8.00305 17.0001 8.00305C16.735 8.00305 16.4806 7.89792 16.2931 7.71079L13.2929 4.71618C13.1107 4.52792 13.0099 4.27577 13.0122 4.01404C13.0144 3.75232 13.1196 3.50195 13.305 3.31688C13.4905 3.1318 13.7413 3.02682 14.0035 3.02455C14.2657 3.02228 14.5183 3.12289 14.707 3.30472L17.7072 6.29933C17.8947 6.48652 18 6.74037 18 7.00506C18 7.26975 17.8947 7.5236 17.7072 7.71079Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0002 5.00856C14.2655 5.00856 14.5198 5.11372 14.7074 5.30092C14.8949 5.48812 15.0003 5.74202 15.0003 6.00676V13.9924C15.0003 14.2571 14.8949 14.511 14.7074 14.6982C14.5198 14.8854 14.2655 14.9906 14.0002 14.9906C13.735 14.9906 13.4806 14.8854 13.2931 14.6982C13.1055 14.511 13.0002 14.2571 13.0002 13.9924V6.00676C13.0002 5.74202 13.1055 5.48812 13.2931 5.30092C13.4806 5.11372 13.735 5.00856 14.0002 5.00856ZM9.7069 12.2885C9.89439 12.4756 9.99971 12.7295 9.99971 12.9942C9.99971 13.2589 9.89439 13.5127 9.7069 13.6999L6.70667 16.6945C6.51805 16.8764 6.26543 16.977 6.00322 16.9747C5.741 16.9724 5.49017 16.8674 5.30474 16.6824C5.11932 16.4973 5.01415 16.2469 5.01187 15.9852C5.00959 15.7235 5.11039 15.4713 5.29256 15.2831L8.29279 12.2885C8.48034 12.1013 8.73466 11.9962 8.99985 11.9962C9.26503 11.9962 9.51936 12.1013 9.7069 12.2885Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.29281 12.2892C2.48035 12.1021 2.73468 11.9969 2.99986 11.9969C3.26505 11.9969 3.51938 12.1021 3.70692 12.2892L6.70715 15.2838C6.80267 15.3759 6.87885 15.486 6.93127 15.6078C6.98368 15.7296 7.01127 15.8606 7.01242 15.9931C7.01358 16.1257 6.98827 16.2571 6.93799 16.3798C6.8877 16.5025 6.81344 16.6139 6.71954 16.7076C6.62564 16.8014 6.51398 16.8755 6.39108 16.9257C6.26817 16.9759 6.13648 17.0011 6.00369 17C5.8709 16.9988 5.73967 16.9713 5.61766 16.919C5.49565 16.8666 5.38529 16.7906 5.29304 16.6953L2.29281 13.7006C2.10532 13.5135 2 13.2596 2 12.9949C2 12.7302 2.10532 12.4764 2.29281 12.2892Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.00019 14.9906C5.73495 14.9906 5.48058 14.8854 5.29303 14.6982C5.10547 14.511 5.00011 14.2571 5.00011 13.9924V6.00676C5.00011 5.74202 5.10547 5.48812 5.29303 5.30092C5.48058 5.11372 5.73495 5.00856 6.00019 5.00856C6.26542 5.00856 6.5198 5.11372 6.70735 5.30092C6.8949 5.48812 7.00026 5.74202 7.00026 6.00676V13.9924C7.00026 14.2571 6.8949 14.511 6.70735 14.6982C6.5198 14.8854 6.26542 14.9906 6.00019 14.9906Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.2 5.47059H2.8C2.58783 5.47059 2.38434 5.34044 2.23431 5.10878C2.08429 4.87712 2 4.56291 2 4.23529C2 3.90767 2.08429 3.59347 2.23431 3.36181C2.38434 3.13015 2.58783 3 2.8 3H17.2C17.4122 3 17.6157 3.13015 17.7657 3.36181C17.9157 3.59347 18 3.90767 18 4.23529C18 4.56291 17.9157 4.87712 17.7657 5.10878C17.6157 5.34044 17.4122 5.47059 17.2 5.47059ZM14.5333 11.2353H5.46667C5.25449 11.2353 5.05101 11.1051 4.90098 10.8735C4.75095 10.6418 4.66667 10.3276 4.66667 10C4.66667 9.67238 4.75095 9.35818 4.90098 9.12651C5.05101 8.89485 5.25449 8.76471 5.46667 8.76471H14.5333C14.7455 8.76471 14.949 8.89485 15.099 9.12651C15.249 9.35818 15.3333 9.67238 15.3333 10C15.3333 10.3276 15.249 10.6418 15.099 10.8735C14.949 11.1051 14.7455 11.2353 14.5333 11.2353ZM11.3333 17H8.66667C8.45449 17 8.25101 16.8699 8.10098 16.6382C7.95095 16.4065 7.86667 16.0923 7.86667 15.7647C7.86667 15.4371 7.95095 15.1229 8.10098 14.8912C8.25101 14.6596 8.45449 14.5294 8.66667 14.5294H11.3333C11.5455 14.5294 11.749 14.6596 11.899 14.8912C12.049 15.1229 12.1333 15.4371 12.1333 15.7647C12.1333 16.0923 12.049 16.4065 11.899 16.6382C11.749 16.8699 11.5455 17 11.3333 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.62597 10L14.5802 15.5964C14.8601 15.8595 15 16.1943 15 16.6009C15 17.0075 14.8601 17.3423 14.5802 17.6054C14.3003 17.8685 13.944 18 13.5115 18C13.0789 18 12.7227 17.8685 12.4428 17.6054L5.41987 11.0045C5.2672 10.861 5.15931 10.7055 5.09621 10.5381C5.0331 10.3707 5.00104 10.1913 5.00002 10C4.99901 9.80867 5.03107 9.6293 5.09621 9.46188C5.16135 9.29447 5.26923 9.13901 5.41987 8.99552L12.4428 2.39462C12.7227 2.13154 13.0789 2 13.5115 2C13.944 2 14.3003 2.13154 14.5802 2.39462C14.8601 2.6577 15 2.99253 15 3.3991C15 3.80568 14.8601 4.14051 14.5802 4.40359L8.62597 10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.374 10L5.41985 4.40359C5.13995 4.14051 5 3.80568 5 3.3991C5 2.99253 5.13995 2.6577 5.41985 2.39462C5.69975 2.13154 6.05598 2 6.48855 2C6.92112 2 7.27735 2.13154 7.55725 2.39462L14.5801 8.99552C14.7328 9.13902 14.8407 9.29447 14.9038 9.46188C14.9669 9.6293 14.999 9.80867 15 10C15.001 10.1913 14.9689 10.3707 14.9038 10.5381C14.8387 10.7055 14.7308 10.861 14.5801 11.0045L7.55725 17.6054C7.27735 17.8685 6.92111 18 6.48855 18C6.05598 18 5.69974 17.8685 5.41985 17.6054C5.13995 17.3423 5 17.0075 5 16.6009C5 16.1943 5.13995 15.8595 5.41985 15.5964L11.374 10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_3862_27722)">
        <path
          d="M19.8055 8.0415H19V8H10V12H15.6515C14.827 14.3285 12.6115 16 10 16C6.6865 16 4 13.3135 4 10C4 6.6865 6.6865 4 10 4C11.5295 4 12.921 4.577 13.9805 5.5195L16.809 2.691C15.023 1.0265 12.634 0 10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 9.3295 19.931 8.675 19.8055 8.0415Z"
          fill="#FFC107"
        />
        <path
          d="M1.15234 5.3455L4.43784 7.755C5.32684 5.554 7.47984 4 9.99934 4C11.5288 4 12.9203 4.577 13.9798 5.5195L16.8083 2.691C15.0223 1.0265 12.6333 0 9.99934 0C6.15834 0 2.82734 2.1685 1.15234 5.3455Z"
          fill="#FF3D00"
        />
        <path
          d="M10.0002 20C12.5832 20 14.9302 19.0115 16.7047 17.404L13.6097 14.785C12.5721 15.5745 11.3039 16.0014 10.0002 16C7.39916 16 5.19066 14.3415 4.35866 12.027L1.09766 14.5395C2.75266 17.778 6.11366 20 10.0002 20Z"
          fill="#4CAF50"
        />
        <path
          d="M19.8055 8.0415H19V8H10V12H15.6515C15.2571 13.1082 14.5467 14.0766 13.608 14.7855L13.6095 14.7845L16.7045 17.4035C16.4855 17.6025 20 15 20 10C20 9.3295 19.931 8.675 19.8055 8.0415Z"
          fill="#1976D2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3862_27722">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AppleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.2982 10.607C15.3254 13.5445 17.8754 14.5222 17.9036 14.5347C17.882 14.6034 17.4962 15.9278 16.5603 17.2954C15.7512 18.4779 14.9114 19.6561 13.5887 19.6808C12.289 19.7045 11.8711 18.9098 10.385 18.9098C8.89934 18.9098 8.43512 19.6561 7.20465 19.7045C5.92778 19.7529 4.95543 18.4256 4.13965 17.2476C2.47278 14.8376 1.19887 10.4375 2.90934 7.46731C3.75903 5.99231 5.27778 5.05841 6.92606 5.03435C8.17981 5.01044 9.36324 5.87778 10.1297 5.87778C10.8956 5.87778 12.3337 4.83466 13.8456 4.98778C14.4786 5.01419 16.2551 5.24341 17.3959 6.91341C17.3042 6.97044 15.2762 8.15106 15.2982 10.607ZM12.8556 3.39356C13.5334 2.5731 13.9897 1.4306 13.8653 0.294189C12.8881 0.333408 11.7065 0.945283 11.0057 1.76544C10.3776 2.49153 9.82762 3.65403 9.9759 4.76794C11.0651 4.85231 12.1776 4.2145 12.8556 3.39356Z"
        fill="black"
      />
    </svg>
  );
};

export const MicrosoftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_3862_27735)">
        <path d="M9.50516 9.50516H0V0H9.50516V9.50516Z" fill="#F1511B" />
        <path d="M19.9992 9.50516H10.4941V0H19.9992V9.50516Z" fill="#80CC28" />
        <path d="M9.50492 20.0002H0V10.495H9.50492V20.0002Z" fill="#00ADEF" />
        <path
          d="M19.9992 20.0002H10.4941V10.495H19.9992V20.0002Z"
          fill="#FBBC09"
        />
      </g>
      <defs>
        <clipPath id="clip0_3862_27735">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PassKeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M0 16.8421V13.8947C0 13.2982 0.153684 12.7502 0.461053 12.2505C0.768421 11.7509 1.17614 11.3691 1.68421 11.1053C2.77193 10.5614 3.87719 10.1537 5 9.8821C6.12281 9.61053 7.26316 9.47439 8.42105 9.47368C8.77193 9.47368 9.12281 9.48702 9.47368 9.51368C9.82456 9.54035 10.1754 9.57965 10.5263 9.63158C10.4561 10.6491 10.6404 11.6098 11.0789 12.5137C11.5175 13.4175 12.1579 14.1586 13 14.7368V16.8421H0ZM16.8421 20L15.2632 18.4211V13.5263C14.4912 13.2982 13.8596 12.8642 13.3684 12.2242C12.8772 11.5842 12.6316 10.8428 12.6316 10C12.6316 8.98246 12.9912 8.11403 13.7105 7.39474C14.4298 6.67544 15.2982 6.31579 16.3158 6.31579C17.3333 6.31579 18.2018 6.67544 18.9211 7.39474C19.6404 8.11403 20 8.98246 20 10C20 10.7895 19.7761 11.4912 19.3284 12.1053C18.8807 12.7193 18.3151 13.1579 17.6316 13.4211L18.9474 14.7368L17.3684 16.3158L18.9474 17.8947L16.8421 20ZM8.42105 8.42105C7.26316 8.42105 6.27193 8.00877 5.44737 7.18421C4.62281 6.35965 4.21053 5.36842 4.21053 4.21053C4.21053 3.05263 4.62281 2.0614 5.44737 1.23684C6.27193 0.412281 7.26316 0 8.42105 0C9.57895 0 10.5702 0.412281 11.3947 1.23684C12.2193 2.0614 12.6316 3.05263 12.6316 4.21053C12.6316 5.36842 12.2193 6.35965 11.3947 7.18421C10.5702 8.00877 9.57895 8.42105 8.42105 8.42105ZM16.3158 10.5263C16.614 10.5263 16.8642 10.4253 17.0663 10.2232C17.2684 10.0211 17.3691 9.77123 17.3684 9.47368C17.3677 9.17614 17.2667 8.92632 17.0653 8.72421C16.8639 8.52211 16.614 8.42105 16.3158 8.42105C16.0175 8.42105 15.7677 8.52211 15.5663 8.72421C15.3649 8.92632 15.2639 9.17614 15.2632 9.47368C15.2625 9.77123 15.3635 10.0214 15.5663 10.2242C15.7691 10.427 16.0189 10.5277 16.3158 10.5263Z"
        fill="black"
      />
    </svg>
  );
};

export const MicIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
    >
      <path
        d="M9.625 3.63645C9.625 2.13022 8.44975 0.90918 7 0.90918C5.55025 0.90918 4.375 2.13022 4.375 3.63645V9.091C4.375 10.5972 5.55025 11.8183 7 11.8183C8.44975 11.8183 9.625 10.5972 9.625 9.091V3.63645Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M0.875 8.18164V9.09073C0.875 10.7785 1.52031 12.3971 2.66897 13.5905C3.81763 14.7839 5.37555 15.4544 7 15.4544M7 15.4544C8.62445 15.4544 10.1824 14.7839 11.331 13.5905C12.4797 12.3971 13.125 10.7785 13.125 9.09073V8.18164M7 15.4544V19.0907M7 19.0907H4.375M7 19.0907H9.625"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="112"
      height="98"
      viewBox="0 0 112 98"
      fill="none"
    >
      <path
        d="M58.7345 24.0166C58.1039 23.8266 57.7447 23.157 57.9328 22.52C60.1235 15.0844 66.9464 9.625 75.0647 9.625C75.7226 9.625 76.2562 10.164 76.2562 10.8285C76.2562 11.4929 75.7226 12.0319 75.0647 12.0319C68.2606 12.0319 62.1549 16.6265 60.2163 23.2058C60.0299 23.842 59.3678 24.2073 58.7346 24.0165L58.7345 24.0166Z"
        fill="currentColor"
      />
      <path
        d="M91.7452 69.7966H84.5964C83.9385 69.7966 83.4049 69.2576 83.4049 68.5931C83.4049 67.9286 83.9385 67.3897 84.5964 67.3897H91.7452C101.6 67.3897 109.617 59.2913 109.617 49.338C109.617 39.3847 101.6 31.2864 91.7452 31.2864H91.5733C91.2277 31.2864 90.8992 31.1351 90.6728 30.8712C90.4465 30.6073 90.3443 30.2574 90.3937 29.9118C90.5001 29.1623 90.5537 28.4093 90.5537 27.676C90.5537 19.0499 83.6047 12.0312 75.0643 12.0312C71.7418 12.0312 68.5732 13.0799 65.9008 15.0647C65.3136 15.5005 64.4796 15.3071 64.14 14.6546C56.5715 0.0981847 36.8036 -1.8566 26.5549 10.8063C22.2375 16.1409 20.5412 23.0805 21.9005 29.844C22.0502 30.591 21.4843 31.2873 20.7328 31.2873H20.2554C10.401 31.2873 2.38309 39.3857 2.38309 49.3389C2.38309 59.2922 10.401 67.3906 20.2554 67.3906H27.4042C28.062 67.3906 28.5957 67.9296 28.5957 68.594C28.5957 69.2585 28.0621 69.7975 27.4042 69.7975H20.2554C9.08679 69.7975 0 60.6195 0 49.3388C0 38.3746 8.58373 29.3969 19.32 28.9017C18.3115 21.8847 20.24 14.8067 24.7097 9.28305C35.6824 -4.27544 56.7108 -2.75572 65.6 12.363C68.4358 10.5673 71.6808 9.62524 75.0639 9.62524C85.4111 9.62524 93.6103 18.5205 92.8928 28.913C103.53 29.5156 112 38.4459 112 49.338C112 60.6195 102.913 69.7966 91.7446 69.7966L91.7452 69.7966Z"
        fill="currentColor"
      />
      <path
        d="M55.8422 98.0011C39.4174 98.0011 26.0547 84.5044 26.0547 67.9146C26.0547 51.325 39.4172 37.8281 55.8422 37.8281C72.2671 37.8281 85.6297 51.3248 85.6297 67.9146C85.6297 84.5042 72.2671 98.0011 55.8422 98.0011ZM55.8422 40.2356C40.7316 40.2356 28.4382 52.6526 28.4382 67.9146C28.4382 83.1768 40.7319 95.5936 55.8422 95.5936C70.9525 95.5936 83.2461 83.1766 83.2461 67.9146C83.2461 52.6524 70.9525 40.2356 55.8422 40.2356Z"
        fill="currentColor"
      />
      <path
        d="M56.3857 55.9922C57.0077 55.9922 57.5077 56.501 57.5078 57.123V80.0312C57.5077 80.654 57.0076 81.1621 56.3857 81.1621C55.7639 81.162 55.2638 80.6532 55.2637 80.0312V57.123C55.2638 56.501 55.7639 55.9923 56.3857 55.9922Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.5"
      />
      <path
        d="M55.6768 56.2471C56.1176 55.8834 56.7695 55.909 57.1807 56.3242L64.1592 63.373L64.2354 63.459C64.5702 63.8735 64.5702 64.4703 64.2354 64.8848L64.1592 64.9707C63.9674 65.165 63.7222 65.2737 63.4717 65.2979L63.3643 65.3027C63.1129 65.3027 62.8608 65.2179 62.6553 65.0488L62.5703 64.9707L56.3857 58.7236L50.2021 64.9707C49.7914 65.3862 49.1394 65.4122 48.6982 65.0488L48.6133 64.9707C48.176 64.529 48.176 63.8147 48.6133 63.373L55.5918 56.3242L55.6768 56.2471Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.5"
      />
    </svg>
  );
};

export const SparkleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 9L11 7.49999L15 5.99849L16.5 2L18.0014 5.99849L22 7.49999L18.0014 9L16.5 13L15 9ZM6.99998 17L2 15L6.99998 13L9 8.00001L11 13L16 15L11 17L9 22L6.99998 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        fill="currentColor"
      />
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="9.5"
        stroke="currentColor"
      />
      <path
        d="M7.91869 12.5042L5.17719 9.76272L4 10.9399L7.91869 14.8586L16 6.77729L14.8228 5.6001L7.91869 12.5042Z"
        fill="white"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3337 10.6818C13.3337 10.501 13.2634 10.3276 13.1384 10.1997C13.0134 10.0718 12.8438 10 12.667 10H7.33366C7.15685 10 6.98728 10.0718 6.86225 10.1997C6.73723 10.3276 6.66699 10.501 6.66699 10.6818C6.66699 10.8626 6.73723 11.0361 6.86225 11.1639C6.98728 11.2918 7.15685 11.3636 7.33366 11.3636H12.667C12.8438 11.3636 13.0134 11.2918 13.1384 11.1639C13.2634 11.0361 13.3337 10.8626 13.3337 10.6818ZM13.3337 14.3182C13.3337 14.1374 13.2634 13.9639 13.1384 13.8361C13.0134 13.7082 12.8438 13.6364 12.667 13.6364H7.33366C7.15685 13.6364 6.98728 13.7082 6.86225 13.8361C6.73723 13.9639 6.66699 14.1374 6.66699 14.3182C6.66699 14.499 6.73723 14.6724 6.86225 14.8003C6.98728 14.9282 7.15685 15 7.33366 15H12.667C12.8438 15 13.0134 14.9282 13.1384 14.8003C13.2634 14.6724 13.3337 14.499 13.3337 14.3182Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.6986 1.66699C5.07121 1.66699 4.46951 1.91463 4.02587 2.35542C3.58224 2.79621 3.33301 3.39405 3.33301 4.01742V15.9832C3.33301 16.6066 3.58224 17.2044 4.02587 17.6452C4.46951 18.086 5.07121 18.3337 5.6986 18.3337H14.3007C14.9281 18.3337 15.5298 18.086 15.9735 17.6452C16.4171 17.2044 16.6663 16.6066 16.6663 15.9832V6.55417C16.6663 6.22853 16.5597 5.91229 16.3618 5.65246L13.7829 2.26101C13.6426 2.07649 13.4611 1.92682 13.2527 1.82375C13.0444 1.72068 12.8148 1.66702 12.582 1.66699H5.6986ZM4.62333 4.01742C4.62333 3.42768 5.10505 2.94904 5.6986 2.94904H11.9352V6.70716C11.9352 7.06101 12.2242 7.34819 12.5803 7.34819H15.376V15.9832C15.376 16.573 14.8943 17.0516 14.3007 17.0516H5.6986C5.10505 17.0516 4.62333 16.573 4.62333 15.9832V4.01742Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3 5.2H17M15.4444 5.2V16.4C15.4444 17.2 14.6667 18 13.8889 18H6.11111C5.33333 18 4.55556 17.2 4.55556 16.4V5.2M6.88889 5.2V3.6C6.88889 2.8 7.66667 2 8.44444 2H11.5556C12.3333 2 13.1111 2.8 13.1111 3.6V5.2"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

// profile setting icons sidebar

export const ProfileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 4.6C8.88061 4.59979 7.78074 4.89319 6.81018 5.4509C5.83961 6.00861 5.0323 6.81113 4.46882 7.77836C3.90534 8.74559 3.6054 9.84369 3.59894 10.9631C3.59248 12.0824 3.87973 13.1839 4.43201 14.1576C4.80529 13.6725 5.28515 13.2797 5.83447 13.0096C6.3838 12.7395 6.98787 12.5994 7.6 12.6H12.4C13.0121 12.5994 13.6162 12.7395 14.1655 13.0096C14.7149 13.2797 15.1947 13.6725 15.568 14.1576C16.1203 13.1839 16.4075 12.0824 16.4011 10.9631C16.3946 9.84369 16.0947 8.74559 15.5312 7.77836C14.9677 6.81113 14.1604 6.00861 13.1898 5.4509C12.2193 4.89319 11.1194 4.59979 10 4.6ZM16.3544 15.8608C16.4547 15.7301 16.5507 15.5963 16.6424 15.4592C17.5293 14.1414 18.0021 12.5885 18 11C18 6.5816 14.4184 3 10 3C5.58161 3 2.00001 6.5816 2.00001 11C1.99749 12.7574 2.57604 14.4663 3.64561 15.8608L3.64161 15.8752L3.92561 16.2056C4.67591 17.0828 5.60751 17.7869 6.65619 18.2693C7.70487 18.7517 8.84568 19.001 10 19C10.1728 19 10.3445 18.9947 10.5152 18.984C11.9587 18.893 13.3501 18.4104 14.54 17.588C15.109 17.1954 15.6248 16.7308 16.0744 16.2056L16.3584 15.8752L16.3544 15.8608ZM10 6.2C9.36348 6.2 8.75303 6.45286 8.30295 6.90294C7.85286 7.35303 7.6 7.96348 7.6 8.6C7.6 9.23652 7.85286 9.84697 8.30295 10.2971C8.75303 10.7471 9.36348 11 10 11C10.6365 11 11.247 10.7471 11.6971 10.2971C12.1471 9.84697 12.4 9.23652 12.4 8.6C12.4 7.96348 12.1471 7.35303 11.6971 6.90294C11.247 6.45286 10.6365 6.2 10 6.2Z"
        fill="white"
      />
    </svg>
  );
};

export const PreferencesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5714 9.25253C15.0261 9.25253 15.4621 9.06807 15.7836 8.73972C16.1051 8.41138 16.2857 7.96604 16.2857 7.50169C16.2857 7.03734 16.1051 6.592 15.7836 6.26366C15.4621 5.93531 15.0261 5.75085 14.5714 5.75085C14.1168 5.75085 13.6807 5.93531 13.3592 6.26366C13.0378 6.592 12.8571 7.03734 12.8571 7.50169C12.8571 7.96604 13.0378 8.41138 13.3592 8.73972C13.6807 9.06807 14.1168 9.25253 14.5714 9.25253ZM14.5714 11.0034C15.2127 11.0033 15.8411 10.8196 16.3852 10.4731C16.9293 10.1266 17.3674 9.63114 17.6497 9.04308C17.9319 8.45502 18.0471 7.7979 17.982 7.14636C17.9169 6.49482 17.6743 5.87497 17.2816 5.35723C16.8889 4.83949 16.3619 4.4446 15.7604 4.21742C15.159 3.99024 14.5072 3.93988 13.8792 4.07205C13.2511 4.20423 12.672 4.51364 12.2075 4.96514C11.743 5.41664 11.4117 5.99214 11.2514 6.62627H2.85714C2.62981 6.62627 2.4118 6.7185 2.25105 6.88267C2.09031 7.04685 2 7.26951 2 7.50169C2 7.73387 2.09031 7.95653 2.25105 8.12071C2.4118 8.28488 2.62981 8.37711 2.85714 8.37711H11.2514C11.4415 9.12882 11.8707 9.79472 12.4717 10.2701C13.0727 10.7455 13.8113 11.0034 14.5714 11.0034ZM7.14286 14.5051C7.14286 14.9694 6.96225 15.4148 6.64075 15.7431C6.31926 16.0714 5.88323 16.2559 5.42857 16.2559C4.97392 16.2559 4.53788 16.0714 4.21639 15.7431C3.8949 15.4148 3.71429 14.9694 3.71429 14.5051C3.71429 14.0407 3.8949 13.5954 4.21639 13.267C4.53788 12.9387 4.97392 12.7542 5.42857 12.7542C5.88323 12.7542 6.31926 12.9387 6.64075 13.267C6.96225 13.5954 7.14286 14.0407 7.14286 14.5051ZM8.74857 15.3805C8.53839 16.2042 8.04174 16.9215 7.35142 17.3985C6.6611 17.8754 5.82436 18.0793 4.99757 17.9721C4.17077 17.8648 3.41051 17.4538 2.85885 16.8157C2.30719 16.1777 2.00189 15.3563 2 14.5051C1.99972 13.6526 2.30394 12.8292 2.85562 12.1895C3.40729 11.5497 4.16853 11.1375 4.99658 11.0301C5.82462 10.9227 6.66259 11.1275 7.35334 11.6061C8.04409 12.0846 8.54018 12.8041 8.74857 13.6296H17.1429C17.3702 13.6296 17.5882 13.7219 17.7489 13.8861C17.9097 14.0502 18 14.2729 18 14.5051C18 14.7372 17.9097 14.9599 17.7489 15.1241C17.5882 15.2883 17.3702 15.3805 17.1429 15.3805H8.74857Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M10 19C10.9625 19 11.75 18.2615 11.75 17.359H8.25C8.25 18.2615 9.0375 19 10 19ZM15.25 14.0769V9.97436C15.25 7.45538 13.8237 5.34667 11.3125 4.78872V4.23077C11.3125 3.54974 10.7263 3 10 3C9.27375 3 8.6875 3.54974 8.6875 4.23077V4.78872C6.185 5.34667 4.75 7.44718 4.75 9.97436V14.0769L3 15.7179V16.5385H17V15.7179L15.25 14.0769ZM13.5 14.8974H6.5V9.97436C6.5 7.93949 7.82125 6.28205 10 6.28205C12.1788 6.28205 13.5 7.93949 13.5 9.97436V14.8974Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const OrganizationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M18 3H6.79892V7.1204C5.73693 7.33746 4.75356 7.83815 3.95329 8.56925C3.15302 9.30036 2.56573 10.2346 2.25381 11.2727C1.94189 12.3108 1.91699 13.414 2.18176 14.4651C2.44652 15.5162 2.99106 16.476 3.75753 17.2425C4.524 18.0089 5.48377 18.5535 6.53489 18.8182C7.58601 19.083 8.68921 19.0581 9.72732 18.7462C10.7654 18.4343 11.6996 17.847 12.4307 17.0467C13.1619 16.2464 13.6625 15.2631 13.8796 14.2011H18V3ZM13.9868 12.6009C13.89 11.1508 13.2703 9.78507 12.2426 8.7574C11.2149 7.72972 9.8492 7.10995 8.39908 7.01319V4.60015H16.3998V12.6009H13.9868ZM7.99904 8.60054C9.1661 8.60054 10.2854 9.06415 11.1106 9.88939C11.9358 10.7146 12.3995 11.8339 12.3995 13.001C12.3995 14.168 11.9358 15.2873 11.1106 16.1125C10.2854 16.9378 9.1661 17.4014 7.99904 17.4014C6.83197 17.4014 5.71271 16.9378 4.88747 16.1125C4.06223 15.2873 3.59861 14.168 3.59861 13.001C3.59861 11.8339 4.06223 10.7146 4.88747 9.88939C5.71271 9.06415 6.83197 8.60054 7.99904 8.60054Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const Line = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1240"
      height="2"
      viewBox="0 0 1240 2"
      fill="none"
    >
      <path d="M0 1H1240" stroke="#525558" />
    </svg>
  );
};

export const profileImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1240"
      height="2"
      viewBox="0 0 1240 2"
      fill="none"
    >
      <path d="M0 1H1240" stroke="#525558" />
    </svg>
  );
};

export const ErrorFillIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_3946_809)">
        <rect x="1" y="1" width="18" height="18" rx="9" fill="white" />
        <path
          d="M10 1C8.21997 1 6.47991 1.52784 4.99987 2.51677C3.51983 3.50571 2.36628 4.91131 1.68509 6.55585C1.0039 8.20038 0.82567 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.364C4.89472 17.6226 6.49836 18.4798 8.24419 18.8271C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.4722 13.5201 19 11.78 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1ZM8.8825 5.5C8.8825 5.20163 9.00103 4.91548 9.21201 4.7045C9.42299 4.49353 9.70913 4.375 10.0075 4.375C10.3059 4.375 10.592 4.49353 10.803 4.7045C11.014 4.91548 11.1325 5.20163 11.1325 5.5V10.6675C11.1325 10.8152 11.1034 10.9615 11.0469 11.098C10.9903 11.2345 10.9075 11.3585 10.803 11.463C10.6985 11.5675 10.5745 11.6503 10.438 11.7069C10.3015 11.7634 10.1552 11.7925 10.0075 11.7925C9.85977 11.7925 9.71347 11.7634 9.57698 11.7069C9.44049 11.6503 9.31647 11.5675 9.21201 11.463C9.10754 11.3585 9.02467 11.2345 8.96814 11.098C8.9116 10.9615 8.8825 10.8152 8.8825 10.6675V5.5ZM10 15.625C9.74486 15.625 9.49546 15.5493 9.28332 15.4076C9.07118 15.2658 8.90583 15.0644 8.8082 14.8287C8.71056 14.5929 8.68501 14.3336 8.73479 14.0833C8.78456 13.8331 8.90743 13.6032 9.08784 13.4228C9.26824 13.2424 9.4981 13.1196 9.74833 13.0698C9.99857 13.02 10.2579 13.0456 10.4937 13.1432C10.7294 13.2408 10.9309 13.4062 11.0726 13.6183C11.2143 13.8305 11.29 14.0799 11.29 14.335C11.29 14.6771 11.1541 15.0052 10.9122 15.2472C10.6702 15.4891 10.3421 15.625 10 15.625Z"
          fill="#FE7A95"
        />
      </g>
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#FE7A95" />
      <defs>
        <clipPath id="clip0_3946_809">
          <rect x="1" y="1" width="18" height="18" rx="9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CircleCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#2D2F32" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#2D2F32" />
      <path
        d="M7.91869 12.5042L5.17719 9.76272L4 10.9399L7.91869 14.8586L16 6.77729L14.8228 5.6001L7.91869 12.5042Z"
        fill="white"
      />
    </svg>
  );
};

export const CircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#525558" />
    </svg>
  );
};

export const ErrorUnfillIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 12C8.19833 12 8.3647 11.9328 8.4991 11.7984C8.6335 11.664 8.70046 11.4979 8.7 11.3C8.69953 11.1021 8.63233 10.936 8.4984 10.8016C8.36446 10.6672 8.19833 10.6 8 10.6C7.80166 10.6 7.63553 10.6672 7.5016 10.8016C7.36766 10.936 7.30046 11.1021 7.3 11.3C7.29953 11.4979 7.36673 11.6642 7.5016 11.7991C7.63646 11.934 7.8026 12.0009 8 12ZM8 9.2C8.19833 9.2 8.3647 9.1328 8.4991 8.9984C8.6335 8.864 8.70046 8.69786 8.7 8.5V5.7C8.7 5.50167 8.6328 5.33553 8.4984 5.2016C8.364 5.06767 8.19786 5.00047 8 5C7.80213 4.99953 7.636 5.06673 7.5016 5.2016C7.3672 5.33647 7.3 5.5026 7.3 5.7V8.5C7.3 8.69833 7.3672 8.8647 7.5016 8.9991C7.636 9.1335 7.80213 9.20046 8 9.2ZM8 15.5C7.03166 15.5 6.12166 15.3161 5.27 14.9484C4.41833 14.5807 3.6775 14.082 3.0475 13.4525C2.4175 12.823 1.91887 12.0821 1.5516 11.23C1.18433 10.3779 1.00047 9.46786 1 8.5C0.999534 7.53213 1.1834 6.62213 1.5516 5.77C1.9198 4.91787 2.41843 4.17703 3.0475 3.5475C3.67657 2.91797 4.4174 2.41933 5.27 2.0516C6.1226 1.68387 7.0326 1.5 8 1.5C8.9674 1.5 9.87739 1.68387 10.73 2.0516C11.5826 2.41933 12.3234 2.91797 12.9525 3.5475C13.5816 4.17703 14.0804 4.91787 14.4491 5.77C14.8178 6.62213 15.0014 7.53213 15 8.5C14.9986 9.46786 14.8147 10.3779 14.4484 11.23C14.0821 12.0821 13.5834 12.823 12.9525 13.4525C12.3216 14.082 11.5807 14.5809 10.73 14.9491C9.87926 15.3173 8.96926 15.5009 8 15.5ZM8 14.1C9.56333 14.1 10.8875 13.5575 11.9725 12.4725C13.0575 11.3875 13.6 10.0633 13.6 8.5C13.6 6.93667 13.0575 5.6125 11.9725 4.5275C10.8875 3.4425 9.56333 2.9 8 2.9C6.43666 2.9 5.1125 3.4425 4.0275 4.5275C2.9425 5.6125 2.4 6.93667 2.4 8.5C2.4 10.0633 2.9425 11.3875 4.0275 12.4725C5.1125 13.5575 6.43666 14.1 8 14.1Z"
        fill="#FE7A95"
      />
    </svg>
  );
};

export const NotificationImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <rect width="48" height="48" rx="24" fill="#2D2F32" />
      <path
        d="M29.8022 21.5179C31.133 21.5179 32.2118 20.2827 32.2118 18.759C32.2118 17.2352 31.133 16 29.8022 16C28.4714 16 27.3926 17.2352 27.3926 18.759C27.3926 20.2827 28.4714 21.5179 29.8022 21.5179Z"
        fill="white"
      />
      <path
        d="M29.2975 30.5438C29.2975 27.5295 27.1729 25.0859 24.5521 25.0859C21.9313 25.0859 19.8066 27.5295 19.8066 30.5438"
        stroke="white"
        strokeWidth="2.94053"
        strokeLinecap="round"
      />
      <path
        d="M12.7422 30.5451C12.7422 23.0363 18.0299 16.9492 24.5526 16.9492"
        stroke="white"
        strokeWidth="3.22939"
        strokeLinecap="round"
      />
      <path
        d="M36.36 30.5444C36.36 27.5142 35.4989 24.7156 34.043 22.4551"
        stroke="white"
        strokeWidth="3.22939"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NotificationReadImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <circle cx="8" cy="8.5" r="8" fill="#8BB4E3" />
    </svg>
  );
};

export const NotificationNotifyImage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="8" cy="8" r="8" fill="#2D2F32" />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.8571 11H11.1429V16C11.1429 16.2652 11.0224 16.5196 10.8081 16.7071C10.5938 16.8946 10.3031 17 10 17C9.6969 17 9.40621 16.8946 9.19188 16.7071C8.97755 16.5196 8.85714 16.2652 8.85714 16V11H3.14286C2.83975 11 2.54906 10.8946 2.33474 10.7071C2.12041 10.5196 2 10.2652 2 10C2 9.73478 2.12041 9.48043 2.33474 9.29289C2.54906 9.10536 2.83975 9 3.14286 9H8.85714V4C8.85714 3.73478 8.97755 3.48043 9.19188 3.29289C9.40621 3.10536 9.6969 3 10 3C10.3031 3 10.5938 3.10536 10.8081 3.29289C11.0224 3.48043 11.1429 3.73478 11.1429 4V9H16.8571C17.1602 9 17.4509 9.10536 17.6653 9.29289C17.8796 9.48043 18 9.73478 18 10C18 10.2652 17.8796 10.5196 17.6653 10.7071C17.4509 10.8946 17.1602 11 16.8571 11Z"
        fill="#2D2F32"
      />
    </svg>
  );
};

export const NotificationTrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3 5.2H17M15.4444 5.2V16.4C15.4444 17.2 14.6667 18 13.8889 18H6.11111C5.33333 18 4.55556 17.2 4.55556 16.4V5.2M6.88889 5.2V3.6C6.88889 2.8 7.66667 2 8.44444 2H11.5556C12.3333 2 13.1111 2.8 13.1111 3.6V5.2"
        stroke="#2D2F32"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

// export const Icon = () => {
//   return <div>index</div>;
// };
